import { ActionTypes } from './types';
import { ThunkResult } from '../../types';

export const scenarioBranchtrackData = (score: number, isFinished: boolean, questionId: string): ThunkResult => dispatch => {
  dispatch({
    type: ActionTypes.QUESTION_SCENARIO_BRANCHTRACK_DATA,
    payload: { score, isFinished, questionId }
  });
};
